// sets default values, overridden by settings.json, if it exists
export class Settings {
  appUrl: '';
  userConfiguration: UserConfiguration = new UserConfiguration();
 
  isFeatureListEnabled = false;
  isFeatureDownloadReport = false;

  isFeatureEditReportRangeEnabled = true; 
  isFeatureReportDealerEnabled = true;
  isFeatureReportCompetitorEnabled = true;
  admins: string[] = [];

  bootstrapBaseUri = '';
  longRunningRequestTimeout: number = 1200000;// 20 mins

  report: {
    colors:['red']//['#c3002f', '#55a5c2', '#f7ce69', '#b2e56e']
  };

  //baseHrefDynamic = '';
  useIdentityServer = true;
  identityServerUrl = '';

  enableDebug = true;
  showDevMenu = false;
}

export class UserConfiguration {
   /**
     * Set/Access the prop only from service SettingsService (this.settingsService.subFleetId)
     */
  subFleetId = 0;
}


import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {

  //public static readonly CURRENT_USER = "current_user";
  //public static readonly USER_PERMISSIONS = "user_permissions";

  //public static readonly SUB_FLEET_ID = "subFleetId";
  //public static readonly DEALER = "dealerId";
  //public static readonly RANGE = "rangeName";
  public static readonly FILTER_PERIOD = "filterPeriod";
  public static readonly FILTER_SETTINGS = "filterSettings";
  public static readonly FILTER_VALUATION = "filterValuation";
  public static readonly FILTER_BASE = "filterBase";
  public static readonly BASKET_ID_CURRENT = "basketIdCurrent";
  public static readonly REPORT_DEALER_GROUP_BY = "reportDealerGroupBy";
  public static readonly CALL_BACK_URL = "callBackUrl";

}

